/** Route-segment slugs used across breadcrumb navigation and pages. */
export enum BreadcrumbRoute {
  Capabilities = "capabilities",
  Services = "services",
  Solutions = "solutions",
  Workforce = "workforce",
  Lab = "lab",
  Products = "products",
  About = "about-us",
}

/**
 * Mapping of route-segment slugs to human-readable breadcrumb names.
 * Override the default title-cased slug for segments that need a custom label.
 */
export const CATEGORY_MAP: Record<BreadcrumbRoute, string> = {
  [BreadcrumbRoute.Capabilities]: "AI Capabilities",
  [BreadcrumbRoute.Services]: "AI Services",
  [BreadcrumbRoute.Solutions]: "AI Solutions",
  [BreadcrumbRoute.Workforce]: "AI Workforce",
  [BreadcrumbRoute.Lab]: "AI Lab",
  [BreadcrumbRoute.Products]: "AI Products",
  [BreadcrumbRoute.About]: "About",
};
